<template>
  <div class="wd-pl-5 wd-my-4">
    <div class="wd-flex wd-items-center wd-justify-between">
      <h1 class="ma-0 wd-text-2xl wd-leading-8 wd-font-medium">{{ branch.name }}</h1>
      <v-btn v-if="merchantBranches.length" class="wd-text-obase" color="orange50" height="32" variant="text" @click="openMerchantBranchesModal">
        <funnow-icon max-width="24" height="24" image-path="compare-icon.svg" />
      </v-btn>
    </div>
    <MerchantBranchesModal ref="merchantBranchesModal" :branch-id="branch.bid" :items="merchantBranches" />
  </div>
</template>

<script>
import MerchantBranchesModal from '@/components/dialog/funbook/merchant-branches-modal.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'

export default defineComponent({
  components: {
    MerchantBranchesModal,
    FunnowIcon,
  },
  props: {
    branch: { type: Object, default: () => ({}) },
    merchantBranches: { type: Array, default: () => [] },
  },
  setup() {
    const merchantBranchesModal = ref(null)

    function openMerchantBranchesModal() {
      merchantBranchesModal.value.showModal()
    }

    return {
      openMerchantBranchesModal,
      merchantBranchesModal,
    }
  },
})
</script>
